if (!customElements.get('gamification-bar')) {
    class GamificationBar extends HTMLElement {
        constructor() {
            super();
            this.loader = null;
            this.progressBar = null;
            this.cartDrawer = null;
            this.isUpdating = false;
            this.isAddingGift = false;
        }

        connectedCallback() {
            this.loader = this.querySelector(".loading-overlay--gamification-bar");
            this.progressBar = this.querySelector(".gamification-bar");
            this.cartDrawer = document.querySelector("cart-drawer.cart-drawer");

            this.updateGamificationBar();
            this.observeCartUpdates();
        }

        async fetchCart() {
            try {
                const response = await fetch("/cart.js");
                return await response.json();
            } catch (error) {
                return null;
            }
        }

        async updateGamificationBar() {
            if (this.isUpdating) return;
            this.isUpdating = true;

            const cart = await this.fetchCart();
            if (!cart) {
                this.isUpdating = false;
                return;
            }

            const cartTotal = cart.items_subtotal_price / 100;
            const mysteryGiftTrigger = this.querySelector("[data-mystery-gift]");
            if (!mysteryGiftTrigger || !this.progressBar) {
                this.isUpdating = false;
                return;
            }

            const mysteryGiftThreshold = parseFloat(mysteryGiftTrigger.querySelector(".bold-text")?.textContent.replace("$", ""));
            const mysteryGiftProduct = mysteryGiftTrigger.dataset.mysteryGift;
            const mysteryGiftInCart = cart.items.some(item => item.id == mysteryGiftProduct);

            this.toggleLoader(true);

            try {
                if (cartTotal >= mysteryGiftThreshold) {
                    if (!mysteryGiftInCart && !this.isAddingGift) {
                        this.isAddingGift = true;
                        await this.updateCart(mysteryGiftProduct, 1, true);
                        this.isAddingGift = false;
                    }
                } else if (mysteryGiftInCart) {
                    await this.updateCart(mysteryGiftProduct, 0);
                }
            } finally {
                this.toggleLoader(false);
                this.isUpdating = false;
            }
        }

        async updateCart(productId, quantity, isGift = false) {
            const endpoint = quantity > 0 ? "/cart/add.js" : "/cart/change.js";
            const body = quantity > 0
                ? { id: productId, quantity, properties: isGift ? { _isGWP: true } : {} }
                : { id: productId, quantity };

            try {
                const response = await fetch(endpoint, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(body)
                });

                if (!response.ok) throw new Error(`Failed to update cart: ${response.statusText}`);

                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } catch (error) {
                console.error(error);
            }
        }

        toggleLoader(show) {
            if (this.loader) this.loader.toggleAttribute("show", show);
            if (this.cartDrawer) this.cartDrawer.classList.toggle("cart-drawer--disabled", show);
        }

        observeCartUpdates() {
            document.addEventListener("line-item:change:end", (evt) => {
                if (!this.isUpdating) {
                    this.isUpdating = true;
                    this.updateGamificationBar().then(() => {
                        this.isUpdating = false;
                    });
                }
            });
        }
    }

    customElements.define("gamification-bar", GamificationBar);
}
